import { render, staticRenderFns } from "./FullscreenHouseCarousel.vue?vue&type=template&id=5dd5eb05&scoped=true&"
import script from "./FullscreenHouseCarousel.vue?vue&type=script&lang=js&"
export * from "./FullscreenHouseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenHouseCarousel.vue?vue&type=style&index=0&id=5dd5eb05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5eb05",
  null
  
)

export default component.exports